// extracted by mini-css-extract-plugin
export default {"container":"xHZhkq","button":"XbzEKa","title":"luNjwR","panel":"y6c6Po","open":"OCNl5A","leftIcon":"ssxuZI","rightIcon":"n0_oGE"};